export function readUrl (input, target, complete) {
    const $target = jQuery(target);

    if (input && target) {
        if (input.files && input.files.length) {
            let reader = new FileReader(),
                src = null,
                img = new Image(),
                data = {};

            reader.onload = function (e) {
                src = e.target.result;
                if (target) $target.attr('src', src);

                img.src = src;
                img.onload = function () {
                    data.width = img.width;
                    data.height = img.height;
                    data.src = img.src;
                    complete && complete(data);
                };
            };
            reader.readAsDataURL(input.files[0]);
        }
    }
}